import { getFullLocalUrl } from "@app/helpers/useAppContent"

export type KundeavisApiResponse = {
    nation?: { url?: string }
}

export const fetchKundeavis = async (): Promise<KundeavisApiResponse> => {
    const url = getFullLocalUrl("/api/app/common/kundeavis")
    const response = await fetch(url)

    if (!response.ok) {
        throw new Error("Network response was not ok")
    }

    return (await response.json()) as KundeavisApiResponse
}
